//components
import AboutInfo from "../components/AboutInfo";
import AboutParts from "../components/AboutParts";
import Footer from "../components/Footer";
import GalleryCarousel from "../components/GalleryCC";
import VideoCarousel from "../components/VideoGalleryCC";
import FooterCopyright from "../components/FooterCopyright";
const imageUrls = [
  "https://www.littlesanctumpreschools.in/googleads3.jpg",
  "https://www.littlesanctumpreschools.in/googleads2.jpg",
  "https://www.littlesanctumpreschools.in/googleads1.jpg",
  "https://www.littlesanctumpreschools.in/googleads4.jpg",
  "https://www.littlesanctumpreschools.in/1.jpg",
  "https://www.littlesanctumpreschools.in/2.jpg",
  "https://www.littlesanctumpreschools.in/3.jpg",
  "https://www.littlesanctumpreschools.in/4.jpg",
  "https://www.littlesanctumpreschools.in/5.jpg",
  "https://www.littlesanctumpreschools.in/6.jpg",
  "https://www.littlesanctumpreschools.in/7.jpg",
  "https://www.littlesanctumpreschools.in/8.jpg",
  "https://www.littlesanctumpreschools.in/9.jpg",
  "https://www.littlesanctumpreschools.in/10.jpg",
  "https://www.littlesanctumpreschools.in/11.jpg",
  "https://www.littlesanctumpreschools.in/12.jpg"
];
const videoIds = ["Rnpw-X9j1Fw", "iG7njbhMiJ8", "bbFAzKQSmn0"];
const About = () => {
  return (
    <>
      <div className="pages">
        <h2 className="title">About us</h2>
      </div>
      <AboutInfo />
      <GalleryCarousel images={imageUrls} />
      <VideoCarousel videoIds={videoIds} />
      <AboutParts />
      <Footer />
      
<FooterCopyright />
    </>
  )
}

export default About